import { Stack, Typography } from '@mui/material';
import { currencyFormatter } from 'core/utils/commonUtils';
import { useMemo, type FC } from 'react';
import type { MarkupTotals } from './orderProjectUtils';

const Total: FC<TotalProps> = ({ totalSum, markup }) => {
  const hasMarkup = useMemo(() => markup.total > 0, [markup]);

  const Markup: FC<{ markup: MarkupTotals }> = (params) => (
    <Typography variant='body2'>
      Наценка: {currencyFormatter.format(params.markup.total)}
      {params.markup.user > 0 && ` (${currencyFormatter.format(params.markup.user)})`}
    </Typography>
  );

  return (
    <Stack direction={'row'} gap={2}>
      <Typography variant='subtitle2'>
        Итого: {currencyFormatter.format(totalSum)}
      </Typography>
      {hasMarkup && <Markup markup={markup} />}
    </Stack>
  );
};

interface TotalProps {
  totalSum: number;
  markup: MarkupTotals;
}

export default Total;
